function getOrGenerateReviewCount(productId) {
    let storedCount = localStorage.getItem(`reviewCount_${productId}`);

    if (!storedCount) {
        let randomReviewCount = Math.floor(Math.random() * 99) + 1;
        localStorage.setItem(`reviewCount_${productId}`, randomReviewCount);
        storedCount = randomReviewCount;
    }

    return parseInt(storedCount, 10);
}

function applyRandomReviewCounts() {
    let reviewElements = document.querySelectorAll(".rating-count, .product-review-count, .jdgm-rev-widg__summary-text");

    reviewElements.forEach(function (element) {
        let productId = element.closest("[data-product-id]")?.getAttribute("data-product-id") || element.getAttribute("data-product-id");

        if (productId) {
            let totalReviews = getOrGenerateReviewCount(productId);

            if (element.classList.contains("jdgm-rev-widg__summary-text")) {
                element.innerText = `Based on ${totalReviews} reviews`;
            } else {
                element.innerText = `(${totalReviews})`;
            }

            element.style.display = "inline";
            applyRandomHistogramValues(productId, totalReviews); // Ensure histogram values update with correct count
        }
    });

    let judgeMeReviewCount = document.querySelector(".jdgm-review-widget .jdgm-review-count");
    if (judgeMeReviewCount) {
        let productId = judgeMeReviewCount.closest("[data-product-id]")?.getAttribute("data-product-id");
        if (productId) {
            let totalReviews = getOrGenerateReviewCount(productId);
            judgeMeReviewCount.innerText = totalReviews;
        }
    }

    let recommendedProducts = document.querySelectorAll(".you-may-also-like .rating-count, .recently-viewed .rating-count");

    recommendedProducts.forEach(function (element) {
        let productId = element.closest("[data-product-id]")?.getAttribute("data-product-id");

        if (productId) {
            let totalReviews = getOrGenerateReviewCount(productId);
            element.innerText = `(${totalReviews})`;
            element.style.display = "inline";
        }
    });
}

function applyRandomHistogramValues(productId, totalReviews) {
    let container = document.querySelector(`[data-product-id="${productId}"] .jdgm-histogram`);
    if (!container) return;

    let bars = container.querySelectorAll(".jdgm-histogram__bar-content");
    let numbers = container.querySelectorAll(".jdgm-histogram__frequency");

    if (numbers.length === 0 || totalReviews === 0) {
        numbers.forEach(num => num.style.display = "none");
        return;
    }

    // 🔥 Identify visible bars (width > 0)
    let visibleBars = Array.from(bars).filter(bar => parseInt(bar.style.width) > 0);
    let visibleIndexes = visibleBars.map(bar => Array.from(bars).indexOf(bar));

    if (visibleIndexes.length > 0) {
        let remaining = totalReviews;
        let newValues = Array(numbers.length).fill(0);

        visibleIndexes.forEach((index, i) => {
            if (i === visibleIndexes.length - 1) {
                newValues[index] = remaining; // Last one gets the rest
            } else {
                let maxForThis = Math.floor(remaining * 0.6);
                let randomNum = Math.floor(Math.random() * (maxForThis + 1));
                remaining -= randomNum;
                newValues[index] = randomNum;
            }
        });

        // Apply random numbers ONLY to visible bars
        numbers.forEach((num, index) => {
            if (visibleIndexes.includes(index)) {
                num.textContent = newValues[index];
                num.style.display = "inline";
            } else {
                num.style.display = "none"; // Hide numbers if no bar
            }
        });
    } else {
        // Hide all numbers if no bars are visible
        numbers.forEach(num => num.style.display = "none");
    }
}

// Shopify AJAX filtering fix (detects URL changes)
let lastUrl = location.href;
new MutationObserver(() => {
    if (location.href !== lastUrl) {
        lastUrl = location.href;
        setTimeout(applyRandomReviewCounts, 500);
    }
}).observe(document.body, { childList: true, subtree: true });

// Observe dynamic content updates (AJAX-loaded sections)
const observer = new MutationObserver(() => {
    setTimeout(applyRandomReviewCounts, 500);
});

function startObserver() {
    let targetSections = document.querySelectorAll(".you-may-also-like, .recently-viewed, .grid, .collection-products, [data-section-type='collection']");

    targetSections.forEach(section => {
        observer.observe(section, { childList: true, subtree: true });
    });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        applyRandomReviewCounts();
        startObserver();
    }, 1000);
});

document.addEventListener("shopify:section:load", applyRandomReviewCounts);
document.addEventListener("shopify:section:updated", applyRandomReviewCounts);
document.addEventListener("ajaxContentUpdated", applyRandomReviewCounts);

setTimeout(() => {
    applyRandomReviewCounts();
}, 1500);
